import type { IconSvgObject } from './types';

const FishingRodIcon: IconSvgObject = [
  ["path", { d: "M9 19C10.1046 19 11 18.1046 11 17C11 15.8954 10.1046 15 9 15C7.89543 15 7 15.8954 7 17C7 18.1046 7.89543 19 9 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 16H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 2L3.41421 19.5858C3.149 19.851 3 20.2107 3 20.5858C3 21.3668 3.63317 22 4.41421 22C4.78929 22 5.149 21.851 5.41421 21.5858L8 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FishingRodIcon;
